import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { ClassifyFormComponent } from './classify-form/classify-form.component';
import { AuthGuard } from '../shared/guards/auth.guard';

const ROUTES: Routes = [
  {
    path: '',
    children: [
      { path: '', component: ClassifyFormComponent, canActivate: [AuthGuard] }
    ]
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(ROUTES)
  ],
  exports: [RouterModule],
  declarations: []
})
export class ClassificationRoutingModule { }
